var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForcefieldLogoSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 344,
    viewBox: "0 0 344 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M323.186 20.7634C277.928 -24.3859 173.555 6.53731 90.0532 89.8515C6.55997 173.157 -24.4459 277.296 20.8122 322.445C66.0703 367.594 170.443 336.662 253.945 253.357C337.447 170.051 368.444 65.9126 323.186 20.7634ZM248.882 247.797H95.4085V94.6736H248.882V247.797Z",
    fill: "#FF5714"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForcefieldLogoSmall);
export default __webpack_public_path__ + "static/media/forcefield-logo-small.bc47689c27be1a17ab16c536f60159e3.svg";
export { ForwardRef as ReactComponent };